export default __webpack_public_path__ + "static/media/service-hardware-development.77d24b69.jpg";